import { Col, Row } from 'antd';
import { AiFillStar } from 'react-icons/ai';
import React from 'react';

export const HotelRating = ({ data, reviewRef }) => {

    const globalRatingLogo = (
        <div className='d-flex align-items-center'>
            {
                [...Array(5)].map((_, i) => (
                    <AiFillStar key={i} style={{ color: '#eb6957'}} size={30} />
                ))
            }
        </div>
    )
    const RatingCard = ({ text, rating, logoSrc = null, width=100 }) => (
        <Col xs={24} md={8}>
            <div className='p-3 h-100 d-flex flex-column align-items-center justify-content-between' style={{ backgroundColor: '#f3f6f8', borderRadius: 10 }}>
                <div className='d-flex my-2 align-items-center justify-content-center'>
                    {
                        logoSrc ? (
                            <img
                                src={logoSrc} alt='...'
                                style={{
                                    width: width,
                                    height: 50,
                                    objectFit: 'contain'
                                }}
                            />
                        ) : (
                            globalRatingLogo
                        )
                    }
                </div>
                <h3 className='text-center fw-bold'>{text}</h3>
                <div className='d-flex align-items-center justify-content-center'>
                    <AiFillStar style={{ color: '#eb6957', fontSize: 30}}  />
                    <h1 className='fw-bold mx-2 mb-0' style={{fontSize: 30}}>{rating}</h1>
                </div>
            </div>
        </Col>
    )

    return (
        <div className='mb-5'>
            <h3 ref={reviewRef} className='mb-3'>Ratings</h3>
            <Row gutter={[16, 16]}>
                {
                    data?.rating?.global &&
                    <RatingCard text='Global Rating' rating={data.rating.global} />
                }
                {
                    data?.rating?.google &&
                    <RatingCard text='Google Rating' rating={data.rating.google} logoSrc={'/img/google-rating.png'}/>
                }
                {
                    data?.rating?.tripadvisor &&
                    <RatingCard text='Tripadvisor Rating' rating={data.rating.tripadvisor} logoSrc={'/img/tripadvisor-rating.png'} width={150}/>
                }
            </Row>
        </div>

    )
}
